import React from 'react'
import { Grid, GridRow,Button, GridColumn, Header, Container, Label, Icon, Confirm, } from 'semantic-ui-react'
import { connect } from 'react-redux'
import {launchDice} from '../reducers/dice/index'
import FormSevenWords from './FormSevenWords'
import { launchQuestion, launchTwoWords, launchVotation, launchSong, launchChoice, launchSevenWords, endGame } from '../reducers/game'
import { resetResult, sendResult } from '../reducers/result'
import { initiateDB } from '../reducers/miniDB'
import soundUrlQuest from '../assets/000002.mp3'


const myPath = '../assets/';
//const myPath = '  http://s3.amazonaws.com/cicciolanciabucket/assets/';


const createDiceUrl = (number) => (
    myPath+""+number+".png"
 )
 
export class ImproviserPage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            msToAnswer: 30000,
            jump: 5000,
            result:0
        }
    }

    componentDidMount() {
        if (this.props.onMount)
            this.props.onMount()
        this.props.onInitiateDB();
    }

  
    launchDice = () =>{
            this.props.onLaunchDice();
        }

    resetResult = () =>{
        this.props.onResetResult();
    }

    getDiceResult = () =>{
        this.props.onGetDiceResult();
    }

    makeAQuestion = () =>{
        this.props.onLaunchQuestion()
    }

    makeTwoWords = () =>{
        this.props.onLaunchTwoWords();
    }

    makeSevenWords = () =>{
        this.props.onLaunchSevenWords();
    }

    makeSong = () =>{
        this.props.onLaunchSong()
    }

    dumbFunction = () =>{
    }

    makeVotation = () =>{
        this.props.onResetResult();
        this.props.onLaunchVotation()
    }

    makeChoice = () =>{
        this.props.onResetResult();
        this.props.onLaunchChoice()
    }


    handleAnswer = (result) =>{
        if (result == 0) result = 1;
        this.setState({result:result})
        this.props.onAnswer(this.state.result);
    }


    createButton=(nome,icona, funzione, available) =>{
        if (available)
            return(
            <Button fluid size='huge' color='green' onClick={funzione}>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name={icona} size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            {nome}
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>)
        else
        return(
            <Button fluid size='huge' color='green' disabled>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name={icona} size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            {nome}
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>
        )
    }

    createFakeButton=() =>{
        return(
            <Button fluid size='huge' color='gray' disabled>
                <Grid verticalAlign='middle'> 
                    <GridRow>
                        <GridColumn width={8}>
                            <Icon name='x' size='huge'/>
                        </GridColumn>
                        <GridColumn width={8}>
                            NON DISPONIBILE
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Button>
        )
    }


    createControlPanel = (numPlayers) =>{
        return (
            <Grid Celled>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                        <Header color='blue' as='h2'><Icon name='gamepad'/>{'LISTA GIOCHI'}</Header> 
                        </Container>
                    </GridColumn>  
                </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                                   {this.createButton('LANCIA IL DADO', 'sync', this.launchDice, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                    </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                                  {this.createButton('LANCIA UNA DOMANDA', 'question circle', this.makeAQuestion, this.props.questionsAvailable&&(numPlayers>=1))}
                        </Container>
                    </GridColumn>
                    </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                            {this.createButton('LANCIA DUE PAROLE', 'wechat', this.makeTwoWords, this.props.twoWordsAvailable&&(numPlayers>=2))}
                            </Container>
                     </GridColumn>
                     </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                            {this.createButton('LANCIA VOTAZIONE', 'hand paper', this.makeVotation, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                                   {this.createButton('LANCIA UNA CANZONE', 'music', this.makeSong, this.props.songAvailable&&(numPlayers>=1))}
                        </Container>
                    </GridColumn>
                    </GridRow>
                <GridRow>
                   <GridColumn>
                        <Container textAlign='center'>
                                  {this.createButton('FAI SCEGLIERE A LORO', 'thermometer', this.makeChoice, numPlayers>=1)}
                        </Container>
                    </GridColumn>
                    </GridRow>
                <GridRow>
                    <GridColumn>
                        <Container textAlign='center'>
                         {this.createButton('LANCIA SEVEN WORDS', 'puzzle', this.makeSevenWords, this.props.sevenWordsAvailable&&(numPlayers>=7))}
                        </Container>
                     </GridColumn>
                </GridRow>
            </Grid>
        )
    }

    render() {
        const { result, selectedName,selectedName2,numPlayers, user} = this.props
        if (this.props.gameType == 6){
            if (this.props.game.number == 7){
                return (
                    <Grid centered verticalAlign='middle' celled>
                    <GridRow centered>
                        <GridColumn centered>
                            <audio ref="audio_tag" src={soundUrlQuest} autoPlay/>
                                <FormSevenWords msToAnswer={this.state.msToAnswer} jump={this.state.jump} handleAnswer={this.handleAnswer} onGameEnded={this.props.onGameEnded}/>
                        </GridColumn>
                    </GridRow> 
                </Grid> 
                )
            }
        }else return(
            <Grid centered verticalAlign='middle' celled>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                    <Header color='red' as='h2'>{'PANNELLO DI CONTROLLO DI '+user.username}</Header> 
                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn centered>
                    <Container textAlign='center'>
                    <Container textAlign='center'>
                        <Grid>
                          <GridColumn centered>    
                          <GridRow>
                          <Container textAlign='center'>
                              <img src={createDiceUrl(result)} width="200"/><br/>
                              </Container>
                              </GridRow>
                            <GridRow>
                            <Container textAlign='center'>
                            {selectedName?
                                <Label size='big'>
                                    {selectedName} {}
                                </Label>
                            :                               
                               <Label size='big'>WAIT</Label>
                            }
                            </Container>
                            </GridRow>
                           <GridRow>
                           <Container textAlign='center'>
                           {selectedName2!=undefined?
                                <Label size='big'>
                                    {selectedName2}
                                </Label>
                            :                               
                              ""
                            }
                            </Container>
                            </GridRow>
                          </GridColumn>
                        </Grid>
                          </Container>                    </Container>
                    </GridColumn>
                </GridRow>
                <GridRow centered>
                    <GridColumn>
                        <Grid centered verticalAlign='middle' celled>
                            <GridRow>
                                <GridColumn>
                                {this.createControlPanel(numPlayers)}
                                </GridColumn>
                            </GridRow>
                        </Grid>
                    </GridColumn>
                </GridRow>
             </Grid>
              
        )
    }
}

const mapStateToProps = (state, {}) => ({
    gameType:state.game?state.game.gameType:0,
    game:state.game,
    user: state.user,
    selectedName: state.selected.selected,
    selectedName2: state.selected.selected2,
    msToAnswer: state.game.msToAnswer,
    result: state.result!=0?state.result.result:0,
    songAvailable: state.miniDB?state.miniDB.songAvailable:false,
    questionsAvailable: state.miniDB?state.miniDB.questionsAvailable:false,
    twoWordsAvailable: state.miniDB?state.miniDB.twoWordsAvailable:false,
    sevenWordsAvailable: state.miniDB?state.miniDB.sevenWordsAvailable:false,
    numPlayers: state.numPlayers
})

const mapDispatchToProps = (dispatch, { socket}) => ({
    onLaunchDice:()=> dispatch(launchDice(socket)),
    onResetResult:()=> dispatch(resetResult(socket)),
    onLaunchQuestion:()=>dispatch(launchQuestion(socket)),
    onLaunchTwoWords:()=>dispatch(launchTwoWords(socket)),
    onLaunchSevenWords:()=>dispatch(launchSevenWords(socket)),
    onLaunchVotation:()=>dispatch(launchVotation(socket)),
    onLaunchSong:()=>dispatch(launchSong(socket)),
    onLaunchChoice:()=>dispatch(launchChoice(socket)),
    onInitiateDB:()=>dispatch(initiateDB(socket)),
    onGameEnded:()=>dispatch(endGame({socket:socket})),
    onAnswer:(result)=>dispatch(sendResult(socket,result))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImproviserPage)


// WEBPACK FOOTER //
// ./src/components/ImproviserPage.js